import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=54b4da1a&"
import script from "./multiple.vue?vue&type=script&lang=js&"
export * from "./multiple.vue?vue&type=script&lang=js&"
import style0 from "./multiple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports